import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import Home from './Home';
import UsernameLogin from './UsernameLogin';

const IndexPage = ({compactView, ...props}) =>
  compactView ? <UsernameLogin {...props} /> : <Home {...props} />;

IndexPage.propTypes = {
  compactView: PropTypes.bool.isRequired
};

function mapStateToProps(state) {
  return {
    compactView: state.xl.compactView
  };
}

export default connect(mapStateToProps)(IndexPage);



// WEBPACK FOOTER //
// ./pages/IndexPage.jsx